import TakerUploadResults from "pages/PanelPage/components/selectedAssessment/assessmentResults/takerResults/TakerResultsbyType/TakerResultsbyType";

export default TakerUploadResults;
